import { z } from 'zod';
import { DisplayReferenceSchema } from '../domain';
import { UUIDSchema } from '../domain/models';
import { PaginationSchema } from '../domain/pagination';
import { PaginatedBundleSchema, PeriodSchema } from '../domain/schema';

const FlagStatusSchema = z.enum(['active', 'inactive', 'entered-in-error']);

export const FlagBaseSchema = z.object({
  note: z.string(),
});

export const FlagSchema = FlagBaseSchema.extend({
  subject: DisplayReferenceSchema,
  encounter: DisplayReferenceSchema,
  practitioner: DisplayReferenceSchema,
  status: FlagStatusSchema,
  period: PeriodSchema,
});
export type Flag = z.infer<typeof FlagSchema>;

export const FlagCreateSchema = FlagBaseSchema.extend({
  carePlan: UUIDSchema,
  subject: UUIDSchema,
  encounter: UUIDSchema,
});

export const FlagSearchSchema = PaginationSchema.extend({
  status: FlagStatusSchema.optional(),
  patientId: z.string().uuid(),
});

export type FlagCreateRequest = z.infer<typeof FlagCreateSchema>;

export const FlagGetAllResponseSchema = PaginatedBundleSchema.extend({
  flags: z.array(FlagSchema),
});

export type FlagStatus = z.infer<typeof FlagStatusSchema>;
export type FlagSearchParams = z.infer<typeof FlagSearchSchema>;
export type FlagGetAllResponse = z.infer<typeof FlagGetAllResponseSchema>;
